import React from 'react';

import BusinessIcon from '@mui/icons-material/Business';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { Box, Grid, Skeleton, Typography } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ChipProposalStatus } from 'common/components';

import ReportStatusIcon from '../../reportList/components/ReportStatusIcon';
import { REPORT_STATUS_CONFIG } from '../../reportList/constants';

import Breadcrumbs from './Breadcrumbs';

const Header = ({ isFetchingOfferDetails, reportDetails }) => {
    const { t } = useTranslation();

    const statusConfig = REPORT_STATUS_CONFIG[reportDetails?.status];

    return (
        <Grid container sx={{ mb: { md: 2, xs: 0 }, pt: 2 }}>
            <Grid
                size={{ md: 14, xs: 18 }}
                sx={{ display: { md: 'block', xs: 'none' } }}
            >
                <Box alignItems="center" display="flex" gap={1}>
                    <FactCheckIcon sx={{ color: 'primary.main' }} />
                    {isFetchingOfferDetails ? (
                        <Skeleton
                            variant="text"
                            sx={{ fontSize: '1rem', width: '100%' }}
                        />
                    ) : (
                        <Typography variant="h4">
                            {get(reportDetails, 'name', null)}
                        </Typography>
                    )}
                </Box>

                <Box alignItems="center" display="flex" gap={1}>
                    <Box sx={{ width: '24px' }} />

                    <BusinessIcon sx={{ color: 'primary.main' }} />

                    {isFetchingOfferDetails ? (
                        <Skeleton
                            variant="text"
                            sx={{ fontSize: '1rem', width: '100%' }}
                        />
                    ) : (
                        <Typography fontWeight="bold" variant="body2">
                            {get(reportDetails, 'branch_office.name', null)}
                        </Typography>
                    )}
                </Box>

                {isFetchingOfferDetails ? (
                    <Skeleton
                        sx={{ fontSize: '1rem', width: '100%' }}
                        variant="text"
                    />
                ) : (
                    <Breadcrumbs pl={4} reportDetails={reportDetails} />
                )}
            </Grid>

            <Grid
                size={{ md: 4, xs: 18 }}
                sx={{ display: { md: 'block', xs: 'none' } }}
                textAlign="right"
            >
                {isFetchingOfferDetails ? (
                    <Skeleton
                        sx={{ fontSize: '1rem', width: '100%' }}
                        variant="text"
                    />
                ) : (
                    <ChipProposalStatus
                        icon={
                            <ReportStatusIcon status={reportDetails?.status} />
                        }
                        label={t(statusConfig?.label)}
                    />
                )}
            </Grid>
        </Grid>
    );
};

Header.propTypes = {
    isFetchingOfferDetails: PropTypes.bool,
    reportDetails: PropTypes.object,
};

export default Header;
